var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.9294 12.8203L6.48425 8.26548L10.8894 12.6706L12.3649 11.1951L7.95976 6.78997L12.536 2.21373L11.0498 0.727528L6.47356 5.30376L2.08978 0.919986L0.614265 2.3955L4.99804 6.77928L0.443191 11.3341L1.9294 12.8203Z","fill":"white"}));
}

Close.defaultProps = {"width":"13","height":"13","viewBox":"0 0 13 13","fill":"none"};

module.exports = Close;

Close.default = Close;
